import { MainLayout } from '@dreamstack/feature-components/src/layout/MainLayout'
import { PropertyFilterOverview } from '@dreamstack/feature-components/src/property/filter/PropertyFilterOverview'
import { propertiesOverviewOtherLocaleUrls } from '@dreamstack/feature-components/src/property/routing/getPropertyUrl'
import { OtherLocaleUrlsContextProvider } from '@dreamstack/i18n'
import { getStaticPropsPlus } from '../../lib/getStaticPropsPlus'

//TODO: FIX MOBILE and MD LAYOUTS

const Index = () => {
  return (
    <>
      <OtherLocaleUrlsContextProvider
        context={propertiesOverviewOtherLocaleUrls}
      >
        <MainLayout navbarProps={{ forceDarkTextColor: true }}>
          <PropertyFilterOverview activatePropertySearchQueryUrlSync={true} />
        </MainLayout>
      </OtherLocaleUrlsContextProvider>
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({})

export default Index
